import { render, staticRenderFns } from "./PropertiesPane.vue?vue&type=template&id=79d7831c&scoped=true&"
import script from "./PropertiesPane.vue?vue&type=script&lang=js&"
export * from "./PropertiesPane.vue?vue&type=script&lang=js&"
import style0 from "./PropertiesPane.vue?vue&type=style&index=0&id=79d7831c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d7831c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDivider,VIcon,VList,VListItem,VListItemGroup,VSpacer,VTab,VTabs,VToolbar})
